export default function LeonAvatar({ className = "w-16 h-16" }) {
  return (
    <svg 
      viewBox="0 0 100 100" 
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background circle */}
      <circle cx="50" cy="50" r="48" fill="#18181b" stroke="#D4AF37" strokeWidth="2"/>
      
      {/* Face - warm skin tone */}
      <ellipse cx="50" cy="55" rx="28" ry="30" fill="#F5D0A9"/>
      
      {/* Hard hat - Gold/Yellow */}
      <ellipse cx="50" cy="28" rx="32" ry="18" fill="#D4AF37"/>
      <rect x="18" y="25" width="64" height="12" rx="2" fill="#D4AF37"/>
      <rect x="22" y="35" width="56" height="4" rx="1" fill="#B38728"/>
      
      {/* Hard hat brim */}
      <ellipse cx="50" cy="38" rx="35" ry="6" fill="#B38728"/>
      
      {/* Hair peeking out - brown */}
      <path d="M 25 42 Q 30 48 35 44" stroke="#5D4037" strokeWidth="3" fill="none" strokeLinecap="round"/>
      <path d="M 75 42 Q 70 48 65 44" stroke="#5D4037" strokeWidth="3" fill="none" strokeLinecap="round"/>
      
      {/* Eyes - big and cute */}
      <ellipse cx="38" cy="55" rx="8" ry="9" fill="white"/>
      <ellipse cx="62" cy="55" rx="8" ry="9" fill="white"/>
      
      {/* Pupils */}
      <circle cx="40" cy="56" r="5" fill="#2D1B00"/>
      <circle cx="64" cy="56" r="5" fill="#2D1B00"/>
      
      {/* Eye shine */}
      <circle cx="42" cy="54" r="2" fill="white"/>
      <circle cx="66" cy="54" r="2" fill="white"/>
      
      {/* Eyebrows - friendly */}
      <path d="M 30 46 Q 38 43 46 46" stroke="#5D4037" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
      <path d="M 54 46 Q 62 43 70 46" stroke="#5D4037" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
      
      {/* Nose - small and cute */}
      <ellipse cx="50" cy="65" rx="3" ry="2" fill="#E8B896"/>
      
      {/* Cheeks - rosy */}
      <circle cx="30" cy="65" r="5" fill="#FFB6B0" opacity="0.5"/>
      <circle cx="70" cy="65" r="5" fill="#FFB6B0" opacity="0.5"/>
      
      {/* Smile - big and happy */}
      <path d="M 38 74 Q 50 84 62 74" stroke="#8B4513" strokeWidth="3" fill="none" strokeLinecap="round"/>
      
      {/* Safety vest collar - Orange/Gold */}
      <path d="M 25 88 L 35 82 L 50 85 L 65 82 L 75 88" fill="#FF9800" stroke="#E65100" strokeWidth="1"/>
      <path d="M 30 90 L 40 86 L 50 88 L 60 86 L 70 90" fill="#D4AF37" stroke="#B38728" strokeWidth="1"/>
      
      {/* Reflective stripes on vest */}
      <line x1="35" y1="85" x2="40" y2="90" stroke="#FFEB3B" strokeWidth="2"/>
      <line x1="65" y1="85" x2="60" y2="90" stroke="#FFEB3B" strokeWidth="2"/>
    </svg>
  );
}
